<template>
  <div class="box">
    <div class="container clearfix">
      <router-link to="/" class="logoBox">
        <a class="logo-txt">戏游互动</a>
      </router-link>
      <div class="searchBox clearfix">
        <div class="inputBox">
          <input type="text" placeholder="" />
        </div>
        <div class="searchBtn">搜索</div>
      </div>
      <div class="codeBox">
        <div class="codeTxt">APP下载</div>
        <qrcode
          value="http://shop.100ytv.com/Index/web.html"
          :options="{ size: 75 }"
        ></qrcode>
      </div>
    </div>
  </div>
</template>

<script>
import logoImg from "@/assets/images/corelogo.png";
import qrcode from "@xkeshi/vue-qrcode";

export default {
  data() {
    return {
      logo: logoImg,
    };
  },
  methods: {},
  created() {},
  components: {
    qrcode,
  },
};
</script>

<style scoped>
.box {
  background: #fff;
  padding: 25px 0 15px 0;
}
.logoBox {
  float: left;
}
.logoBox img {
  width: 100px;
  height: 70px;
}
.logo-txt {
  font-size: 30px;
  font-family: PingFangSC-Medium, PingFang SC;
  color: #66beb2;
  font-size: 20px;
  vertical-align: middle;
}
.searchBox {
  margin-left: 140px;
  margin-top: 10px;
  float: left;
}
.inputBox {
  width: 400px;
  height: 40px;
  line-height: 40px;
  background-color: #fff;
  border: 1px solid #3f8fdf;
  padding: 0 5px 0 5px;
  float: left;
}
.inputBox input {
  width: 100%;
  height: 38px;
  background-color: transparent;
}
.searchBtn {
  width: 90px;
  height: 40px;
  line-height: 40px;
  background-color: #3f8fdf;
  color: #fff;
  font-size: 18px;
  text-align: center;
  cursor: pointer;
  float: right;
}
.codeBox {
  float: right;
}
.codeTxt {
  text-align: center;
  color: #3f8fdf;
  font-size: 12px;
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/mall/private/search.vue